export default __webpack_public_path__ + "static/media/netflix-logo-0.b39480d0.png";